/// <reference path="../../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class NavigationAccordionPageDirectiveController {
        public static $inject : string[] = [
            '$q',
            '$timeout',
            '$mobilityUid',
            '$scope',
            'MobilityButtonCollectionFactory'
        ];

        public pageName: string;
        public pageTitle: string;
        public gainsightGroup: string;
        public href: string;
        public target: string;
        public pageId: string;
        public parentPageId: string;
        public panelBodyClass: string;
        public panelClass: string;
        public menuTitle: string;
        public subMenuTitle: string;
        public isOpen: boolean;
        public isDefault: boolean;
        public isDefaultMobile: boolean;
        public isDefaultSm: boolean;
        public isDefaultMd: boolean;
        public isDefaultLg: boolean;
        public isDefaultXl: boolean;
        public isHidden: boolean;
        public hidePanelHeadingDesktop: boolean;
        public disableAutoFocus: boolean;
        public isComplete: boolean;
        public hideFooter: boolean;
        public hideToolbar: boolean;
        public onHide: any;
        public onBeforeShow: any;
        public onShow: any;
        public onClick: any;
        public buttons: any;
        public accordionNavigationController: any;
        public el: any;
        public buttonCollection: any;
        public leftHeaderButtonCollection: any;
        public rightHeaderButtonCollection: any;

        constructor(public $q: any,
                    public $timeout: any,
                    public $mobilityUid: any,
                    public $scope: any,
                    public MobilityButtonCollectionFactory: any) {
            $scope.directiveController = this;
            this.leftHeaderButtonCollection = this.MobilityButtonCollectionFactory.getInstance();
            this.rightHeaderButtonCollection  = this.MobilityButtonCollectionFactory.getInstance();

            this.leftHeaderButtonCollection.addButton({
                id: 'navBackButton',
                type: 'button',
                classes: 'icon-left ion-chevron-left button-clear button-dark button-small button-padless',
                text: '',
                onClick: () => { this.hidePage(); }
            });

            if (this.buttons && angular.isObject(this.buttons)) {
                if (this.buttons.hasOwnProperty('leftHeaderButtonCollection') && this.buttons.leftHeaderButtonCollection && angular.isArray(this.buttons.leftHeaderButtonCollection)) {
                    this.leftHeaderButtonCollection.addButtons(this.buttons.leftHeaderButtonCollection);
                }
                if (this.buttons.hasOwnProperty('rightHeaderButtonCollection') && this.buttons.rightHeaderButtonCollection && angular.isArray(this.buttons.rightHeaderButtonCollection)) {
                    this.rightHeaderButtonCollection.addButtons(this.buttons.rightHeaderButtonCollection);
                }
            }
        }

        public generatePageId() : void {
            this.pageId = this.$mobilityUid.generate();
        }

        public toggle() : void {
            if (this.isOpen) {
                this.hidePage();
            } else {
                this.showPage();
            }
        }

        public clickHandler() : void {
            if (this.onClick && angular.isFunction(this.onClick)) {
                this.onClick();
            }
        }

        public hidePage() : void {
            this.$timeout(() => {
                this.isOpen = false;
                if (this.onHide && angular.isFunction(this.onHide)) {
                    this.$q.when(this.onHide()).finally(() => {
                        this.isOpen = false;
                    });
                } else {
                    this.isOpen = false;
                }
            });
        }

        public showPage() : void {
            this.accordionNavigationController.pageLoading = true;

            // onBeforeShow can be used to do some whatever things before onShow fires, which
            // is useful to also cancel all onShow actions as well as tab switching tasks
            // i.e. hiding other tabs and showing the new clicked on one, if a false (not just falsey)
            // value is returned from onBeforeShow.
            //
            var onBeforeShow = angular.isFunction(this.onBeforeShow) ?
                this.onBeforeShow : angular.noop;

            this.$q.when(onBeforeShow()).then(
                (onBeforeShowResponse : any) => {
                    // A definite false response from beforeShow means we won't perform the default
                    // show actions, which, as noted above, include an onShow handler as well
                    // as a page transition.
                    //
                    if (onBeforeShowResponse === false) {
                        this.accordionNavigationController.pageLoading = false;
                        return;
                    }

                    if (this.href) {
                        this.accordionNavigationController.pageLoading = false;
                        return;
                    } else {
                        this.accordionNavigationController.hideOtherPages(this);
                        this.$timeout(() => {
                            if (!this.isOpen) {
                                this.isOpen = true;
                                if (this.onShow && angular.isFunction(this.onShow)) {
                                    this.$q.when(this.onShow()).finally(() => {
                                        this.autofocus();
                                        this.isOpen = true;
                                    });
                                } else {
                                    this.autofocus();
                                    this.isOpen = true;
                                }
                            }
                            this.accordionNavigationController.pageLoading = false;
                        }, 500);
                    }
                }
            );
        }

        public autofocus() : void {
            this.$timeout(() => {
                if (!this.disableAutoFocus) {
                    this.el.find('.autofocus:visible').focus();
                } else {
                    this.el.find('.autofocus:visible').blur();
                }
                this.el.scrollTop(0);
            }, 500);
        }

        public isPageOpen() :boolean {
            return this.isOpen;
        }

        public isPageComplete() : boolean {
            return this.isComplete;
        }

        public getParentPage() : any {
            var _parent : any = undefined;
            if (this.parentPageId) {
                angular.forEach(this.accordionNavigationController.pages, (val,idx) => {
                    if (val.pageId == this.parentPageId) {
                        _parent = val;
                        return false;
                    }
                });
            }
            return _parent;
        }

        public getChildPages() : any[] {
            var children : any[] = [];

            angular.forEach(this.accordionNavigationController.pages, (val,idx) => {

                if (val.parentPageId == this.pageId) {
                    children.push(val);
                }
            });
            return children;
        }

        public hasOpenChildPage() : boolean {
            var oc = false;
            var _children = this.getChildPages();
            angular.forEach(_children, (val,idx) => {
                if (val.isOpen) {
                    oc = true;
                    return false;
                }
            });
            return oc;
        }

        public hasChildPage() : boolean {
            return (this.getChildPages().length > 0);
        }

        public setButtonCollection(collection : any) {
            if (this.buttonCollection) {
                throw "Button collection already exists";
            }
            this.buttonCollection = collection;
        }
    }

    getDealerwareWebComponentsModule().controller('NavigationAccordionPageDirectiveController', NavigationAccordionPageDirectiveController);

    export class NavigationAccordionPage implements ng.IDirective {
        public restrict         : string    =   'EA';
        public controller       : any       =   'NavigationAccordionPageDirectiveController';
        public controllerAs     : string    =   'ctrl';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
                                                    'pageName'                  :   '@',
                                                    'pageTitle'                 :   '@',
                                                    'gainsightGroup'            :   '@',
                                                    'href'                      :   '@',
                                                    'target'                    :   '@',
                                                    'parentPageId'              :   '@?',
                                                    'panelBodyClass'            :   '@?',
                                                    'panelClass'                :   '@?',
                                                    'menuTitle'                 :   '@',
                                                    'isOpen'                    :   '=?',
                                                    'onHide'                    :   '&?',
                                                    'onBeforeShow'              :   '&?',
                                                    'onShow'                    :   '&?',
                                                    'onClick'                   :   '&?', // Called only when someone clicks on a navigation item; but not on initial load.
                                                    'isDefault'                 :   '=?',
                                                    'isDefaultMobile'           :   '=?',
                                                    'isDefaultSm'               :   '=?',
                                                    'isDefaultMd'               :   '=?',
                                                    'isDefaultLg'               :   '=?',
                                                    'isDefaultXl'               :   '=?',
                                                    'isHidden'                  :   '=?',
                                                    'hidePanelHeadingDesktop'   :   '=?',
                                                    'subMenuTitle'              :   '=?',
                                                    'buttons'                   :   '=?',
                                                    'disableAutofocus'          :   '=?',
                                                    'hideFooter'                :   '=?',
                                                    'description'               :   '@?',
                                                    'summary'                   :   '=?',
                                                    'warning'                   :   '=?',
                                                    'unsavedChanges'            :   '=?',
                                                    'required'                  :   '=?',
                                                    'hideToolbar'               :   '=?'
                                                };
        public transclude       : boolean   =   true;
        public templateUrl      : any       =   function(element : any,attributes : any) : any { return attributes.template || '/components/navigation/accordion/page/navigation_accordion_page_directive.html'; };
        public static $inject   : string[]  =   [];
        public require          : string[]  =   ['^navigationAccordion'];

        constructor() {}

        public link : ng.IDirectivePrePost = {
            pre: function(scope : any,element : any,attrs : any,ctrl : any) {

                // get the wizard id or create one
                if (attrs && angular.isObject(attrs) && attrs.hasOwnProperty('id')) {
                    scope.directiveController.pageId = attrs.id;
                } else {
                    scope.directiveController.generatePageId();
                }

                scope.directiveController.el = element;
                scope.directiveController.accordionNavigationController = ctrl[0];
                scope.directiveController.accordionNavigationController.addPage(scope.directiveController);

            }
        }

        static factory(): ng.IDirectiveFactory {
            const directive = ($mobilityUid: any) => new NavigationAccordionPage();
            return directive;
        }
    }

    getDealerwareWebComponentsModule().directive("navigationAccordionPage", NavigationAccordionPage.factory());
}
